import { ToastMessage } from "../../../utils/ToastMessage";
import { IONICWrapper } from "../../../utils/common";
import { CAMERA_SOURCE, CONTENT_OR_CONFIG_TABLE_MAPPING, MYLOAD_DOCUMENT_UPLOAD, ESOURCE_TYPE_CHECK } from "../../../utils/constants";
import i18n from "../../../../i18n";

const getFormatedDateTime = (createdDateTime:any) => {
  const actualStartDateTime =(createdDateTime && createdDateTime!= ""  && new Date(parseInt(createdDateTime))) || createdDateTime;
    const monthName: string = actualStartDateTime.toLocaleString('en-US', {month: 'short'});
    const date: number = actualStartDateTime.getDate();
    const time: string = actualStartDateTime.toLocaleString('en-US', {
      timeZone: 'CST',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
    return `${monthName} ${date} ${time} Central`;
  }

  export {getFormatedDateTime}

  export const validateDocumentContent = (content: any) => {
    const approvedDocumentFormat: string =
      (IONICWrapper.details.getKeyValuePairs(
        CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
      ) &&
        IONICWrapper.details.getKeyValuePairs(
          CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
        ).ADD_DOCUMENT_CONFIG &&
        IONICWrapper.details.getKeyValuePairs(
          CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
        ).ADD_DOCUMENT_CONFIG.documentFormat) ||
      MYLOAD_DOCUMENT_UPLOAD.ADD_DOCUMENT_CONFIG.documentFormat;
    let isValidated = true;
    let error: string[] = [];
    if (!approvedDocumentFormat.includes(content.type)) {
      error.push(
        ` Please select documents with .${approvedDocumentFormat
          .split(",")
          .map(item => item.substring(item.indexOf("/") + 1, item.length))
          .join(", .")} format only`
      );
      isValidated = false;
    }
    if (!isValidated && error.length > 0) {
      ToastMessage.open({
        message: `${error.join(",\n")}.`,
        showUndo: false,
        duration: 10000
      });
    }
    return isValidated;
  };
  export const toBase64 = (file : any, source? : any) => 
    new Promise(async (resolve, reject) => {
      const reader: any = new FileReader();
      if (source && source === CAMERA_SOURCE) {
          const imageUrl = await fetch(String(file));
          file = await imageUrl.blob();
      }

      reader.readAsDataURL(file);
      reader.onload = () => {
          let encoded = reader.result.toString().replace(/^data:(.*,)?/, "");
          if (encoded.length % 4 > 0) {
              encoded += "=".repeat(4 - (encoded.length % 4));
          }
          resolve(encoded);
      };
      reader.onerror = (error : any) => reject(error);
  });
  export const contentCreation = async (uploadedDocuments: any[]) => {
    let content: any[] = [];
    for (let i = 0; i < uploadedDocuments.length; i++) {
      await toBase64(uploadedDocuments[i] && uploadedDocuments[i].content, uploadedDocuments[i] && uploadedDocuments[i].source).then(
        response => {
          content.push({
            sequence: uploadedDocuments[i] && uploadedDocuments[i].rank,
            format: uploadedDocuments[i] && uploadedDocuments[i].content.type || "image/jpeg",
            documentBase64: response
          });
        }
      );
    }
    return content.length > 0 ? content : null;
  };
  export const payloadCreationForDocUpload = (data: any) => {
    let payload = new FormData();
    payload.append("shipmentId", data?.shipmentId || "");
    payload.append("sourceSystem", data?.sourceSystem || "");
    payload.append("division", data?.division || "");
    payload.append("invoiceNumber", data?.invoiceNumber || "");
    !!data?.docType && payload.append("docType", data?.docType);
    if (data?.documents?.length > 0) {
      data?.documents?.forEach(async (item: any,index:number) => {
        const file = item.source === CAMERA_SOURCE ? getFileFromBase64(item?.content, `Capture_${index}.jpg`) : item?.content;
        payload.append("files", file);
      });
    }
    return payload;
  };

  export const getFileFromBase64 = (string64:string, fileName:string) => {
    let arr:any[] = string64.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
  let File = window.File;
  if ("File_native" in window) {
    // @ts-ignore
    File = window["File_native"];
  }
    return new File([u8arr], fileName, {type:mime});
  }

  export const getDocTypeDetails = (selectedUploadDocumentType: any) => {
    return selectedUploadDocumentType && selectedUploadDocumentType.value;
  };
  
  export const getSourceSystemDetails = (props: any) => {
    return props && props.sourceTMS;
  };
  
  export const getPayLoadShipmentId = (props: any) => {
    return props && props.shipmentId;
  };

  export const documentTabNamesByModule: any = [
    { name: i18n.t("Available Documents"), key: "documents", visibilityControllKey : ESOURCE_TYPE_CHECK.AVAILABLE_DOCUMENT_SECTION_ROLE },
    { name: i18n.t("Related Documents"), key: "relatedDocuments",visibilityControllKey : ESOURCE_TYPE_CHECK.RELATED_DOCUMENT_SECTION_ROLE }
  ]